import React from "react";
import watermarkImageUrl from "../../assets/img/watermark.png";
import { AsyncImage } from "loadable-image";
import Image from "assets/img/default-img.jpg";

const SmallImage = ({ data, isBtn, fillSlot, handleOpenImageModal, hasAccessToSeeWatermark }) => {
  const wrapperHeight = fillSlot ? "100%" : isBtn ? "90%" : "100%";
  return (
    <div style={{ position: "relative", height: wrapperHeight, width: "100%" }}>
      {/* The original image */}
      <AsyncImage
        onClick={() => handleOpenImageModal(data.img || data.image?.imageUrl||data?.image?.transformedImageUrl || data.imageUrl || data.Orgimg || data.imageUrl ? data.Orgimg || data.imageUrl ||data?.image?.transformedImageUrl || data.img : null, data["styleNumber"] || data?.styleNo)}
        // src={data.img || data.imageUrl || data.Orgimg || data.image?.imageUrl||data.transformedImageUrl ? data.img || data.transformedImageUrl : Image}
        src={data.img || data.imageUrl || data?.image?.transformedImageUrl || data.Orgimg || data?.image?.imageUrl || Image }
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
          objectFit: "fill",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        loader={<div style={{ background: "#888", width: "100%", height: "100%" }} />}
        error={<div style={{ background: "#eee", width: "100%", height: "100%" }} />}
        onContextMenu={(e) => e.preventDefault()}
        onTouchStart={(e) => e.preventDefault()}
        draggable="false"
      />

      {hasAccessToSeeWatermark && (data?.img || data.imageUrl|| data.Orgimg || data.transformedImageUrl) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "95%",
            height: isBtn ? "95%" : "95%",
            backgroundImage: `url(${watermarkImageUrl})`,
            backgroundRepeat: "repeat",
            backgroundSize: "200px 200px",
            opacity: 1,
            pointerEvents: "none",
          }}
        />
      )}
    </div>
  );
};

export default SmallImage;
